import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const LIVE_ROLES = ["tim_keuangan", "direktur"];
const INTERVAL = 15000;

export function useRefreshTick() {
  const { user } = useAuth();
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!LIVE_ROLES.includes(user?.role)) return undefined;
    const bump = () => {
      if (document.visibilityState !== "visible") return;
      if (document.querySelector('[role="dialog"],[role="alertdialog"]')) return;
      setTick((t) => t + 1);
    };
    const id = setInterval(bump, INTERVAL);
    window.addEventListener("focus", bump);
    return () => { clearInterval(id); window.removeEventListener("focus", bump); };
  }, [user?.role]);
  return tick;
}

export function useAutoRefresh(fn) {
  const tick = useRefreshTick();
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => { if (tick) ref.current(true); }, [tick]);
}
